import React, { useState } from 'react';
import PersonIcon from '@material-ui/icons/Person';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardMedia,
  Typography,
  IconButton,
  CardHeader
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import EditIdentityForm from './EditIdentityForm';
import { AlertDialog } from '../UI/AlertDialog';
import LoadingCard from '../UI/LoadingCard';
import API_REST from '../../api-rest-uruk';
import PropTypes from 'prop-types';

export const CardIdentity = (props) => {
  const { classes, identity, getAllIdentities } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteIdentity, setDeleteIdentity] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [editIdentity, setEditIdentity] = useState(false);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const deleteBiometricIdentity = async (choise) => {
    setAnchorEl(null);
    if (choise) {
      setMessage(t('identityListView:removing'));
      setDialogLoading(true);
      API_REST.deleteBiometricIdentity({ userId: identity.userId })
        .then(async () => {
          setMessage(t('identityListView:ready'));
          await getAllIdentities();
          setTimeout(() => setDialogLoading(false), 2000);
        })
        .catch((err) => {
          if (err) {
            setMessage(t('identityListView:error'));
            setTimeout(() => setDialogLoading(false), 2000);
          }
        });
    }
  };

  return (
    <>
      <Card className={classes.card}>
        <div className={classes.cardMedia}>
          {
            identity.photo
              ? <CardMedia
                image={'data:image/jpeg;base64,' + identity.photo}
                title={identity.firstName}
              />
              : <PersonIcon fontSize='large' />
          }
        </div>
        <div>
          <Typography variant='body1'>
            {'ID: ' + identity.userId}
          </Typography>
          {(identity.name || identity.firstName || identity.lastName) &&
            <Typography variant='body1'>
              {t('identityListView:name')} {identity.name && identity.name + ' '} {identity.firstName && identity.firstName + ' '} {identity.lastName && identity.lastName}
            </Typography>}
          <Typography variant='body1'>
            {identity.email ? 'Email: ' + identity.email : 'No Email'}
          </Typography>
          <Typography variant='body1'>
            {t('identityListView:state') + identity.status}
          </Typography>
        </div>
        <CardHeader
          style={{ flexGrow: 1 }}
          action={
            <IconButton aria-label='settings' onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
          }
        />
        <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={() => {
            setAnchorEl(null);
            setDeleteIdentity(true);
          }}
          >
            {t('identityListView:delete')}
          </MenuItem>
          {// Removed for the moment, because it is not working. Waiting for product definition for edit button.
          /* <MenuItem onClick={() => {
            setAnchorEl(null);
            setEditIdentity(true);
          }}
          >
            {t('identityListView:edit')}
          </MenuItem> */}
        </Menu>
      </Card>
      {
        deleteIdentity &&
          <AlertDialog
            description={t('identityListView:deleteMessage')}
            callbackFunc={deleteBiometricIdentity}
            open={deleteIdentity}
            setOpen={setDeleteIdentity}
          />
      }
      {
        editIdentity &&
          <EditIdentityForm
            open={editIdentity}
            setEditIdentity={setEditIdentity}
            identity={identity}
            getAllIdentities={getAllIdentities}
          />
      }
      <LoadingCard open={dialogLoading} loading={dialogLoading} message={message} />
    </>
  );
};

CardIdentity.propTypes = {
  classes: PropTypes.object.isRequired,
  identity: PropTypes.object.isRequired,
  getAllIdentities: PropTypes.func.isRequired
};
